import { Injectable } from '@angular/core';
import { HttpEvent, HttpInterceptor, HttpHandler, HttpRequest, HttpResponse } from '@angular/common/http';
import { Environment } from '../../environments/environment';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import * as moment from 'moment';
import { Router } from '@angular/router';

@Injectable()
export class DebugHttpInterceptor implements HttpInterceptor {
constructor(private router: Router) { }

    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

        const reqTime = new Date();

        return next.handle(req).pipe(map(res => {

            if (res instanceof HttpResponse && res.status === 401) {

                this.router.navigate(['/login']);
            }
            if (res instanceof HttpResponse && !Environment.production) {

                this.debugResponseBodyLength(reqTime, res);
            }

            return res;
        }));
    }

    // Prints the lenth of the response body, prints error if it exceeds CloudFront limit of 6MB
    private debugResponseBodyLength(time: Date, res: HttpResponse<any>) {
        
        if (res == null || res.body == null) {
            return;
        }

        const duration = moment().diff(moment(time), 'millisecond');

        let bodyLength: number;

        if (res.body instanceof Blob) {

            bodyLength = (res.body as Blob).size;
        } else {

            const body = JSON.stringify(res.body);
            bodyLength = body.length;
        }

        // Print the body
        // console.log('Reponse Body: ' + body);
        console.log(`Reponse Size: ${bodyLength / 1024}KB, ${duration}ms, (${res.url})`);

        // Log error if response if too large
        if (bodyLength / 1024 > 6144) {

            console.error('Response exceeds 6MB!');
        }
    }

}
